import { FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { fetchStocksAction, setStockUnsubscribeAction } from 'reducks/stock/actions'
import { StockType } from 'types/stock'
import { mergeListeningStocks } from 'reducks/stock/operations'

const fetchStocks = (params: {
  date: string
  types: string[]
  storeRef: FirebaseDocRefType
  isExcludingDeletedStock?: boolean
}) => {
  const { date, types, storeRef, isExcludingDeletedStock = true } = params
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    // unsubscribeが設定済み（リスナーが設定済み）であればスキップ（重複登録の防止）
    if (getState().stock.is_set_unsubscribe) return

    // typeの指定がなければstocksを初期化する
    if (types.length === 0) {
      dispatch(fetchStocksAction([]))
      return
    }
    let query = storeRef.collection('store_stocks').where('date', '==', date).where('type', 'in', types)

    const manufacturerRef = getState().auth.manufacturer_ref
    if (typeof manufacturerRef !== 'undefined') {
      query = query.where('manufacturer_ref', '==', manufacturerRef)
    }

    const unsubscribe = await query.onSnapshot((snapshots) => {
      const currentStocks: StockType[] = getState().stock.stocks
      mergeListeningStocks(snapshots.docChanges(), currentStocks, dispatch, isExcludingDeletedStock)
    })
    dispatch(setStockUnsubscribeAction(unsubscribe))
  }
}

export default fetchStocks
